var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-vcs-root-arrow",
  "use": "ring-icon-vcs-root-arrow-usage",
  "viewBox": "0 0 19 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 17\" id=\"ring-icon-vcs-root-arrow\"><path d=\"M10.014 10l2.951 4.585 1.5 2.33.041.064L19 10zM3 13V3h10v5.625h3V0H0v16h12.056l-1.931-3z\" /><path d=\"M10.027 10.037l.036-.037h-.06zM10 4v3.208L8.547 8.623l.002.002h2.846L12 8V4zM6 7.208V4H4v4l4.125 4 .904-.934-1.566-2.433z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id